/**
 * @generated SignedSource<<ed7b6b06dcd01e3bd7ebb649f3b5beeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditTimelineEntryDialog_SearchQuery$variables = {
  search?: string | null | undefined;
};
export type EditTimelineEntryDialog_SearchQuery$data = {
  readonly institutes: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type EditTimelineEntryDialog_SearchQuery = {
  response: EditTimelineEntryDialog_SearchQuery$data;
  variables: EditTimelineEntryDialog_SearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "search"
      }
    ],
    "concreteType": "InstituteConnection",
    "kind": "LinkedField",
    "name": "institutes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Institute",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditTimelineEntryDialog_SearchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditTimelineEntryDialog_SearchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa1adf583835daa985d0578b18e939ca",
    "id": null,
    "metadata": {},
    "name": "EditTimelineEntryDialog_SearchQuery",
    "operationKind": "query",
    "text": "query EditTimelineEntryDialog_SearchQuery(\n  $search: String\n) {\n  institutes(name: $search, first: 10) {\n    nodes {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0eb630f3c8211b832648db4af9155e1";

export default node;
